import { render } from "./AuthFrame.vue?vue&type=template&id=eccd0270&scoped=true"
import script from "./AuthFrame.vue?vue&type=script&lang=js"
export * from "./AuthFrame.vue?vue&type=script&lang=js"

import "./AuthFrame.vue?vue&type=style&index=0&id=eccd0270&scoped=true&lang=css"
import "./AuthFrame.vue?vue&type=style&index=1&id=eccd0270&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eccd0270"]])

export default __exports__